export const AppRoutes = {
  Home: "/",
  OTT: "/ott",
  OFC: "/ofc",
  Purchase: "purchase",
  OTTOfferId: ":offerId",
  SKU: ":skuId",
  ThankYou: "/thankyou",
};

export const ExternalRoutes = {
  OF_LOGIN: "https://onefootball.com/payments/sign-in",
  PAYMENTS_URL: "https://payments.onefootball.com/",
};
